<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>添加老师</h1>
      </div>
      <div class="liner"></div>
    </div>


    <div class="main-page" style="padding-bottom:0;">
      <div class="margin-15 text-center">
        <p class="padding-15 margin-15 font-16">面对面扫一扫，邀请老师加入园点</p>
        <div class="margin-15"><div class="text-center" id="code"></div></div>
        <div class="liner"></div>
        <p class="padding-15 gray">或者您还可以</p>

        <div class="shall padding-15">
        <div class="clearfix font-10">
          <div class="col-xs-6"><a class="icon-weixin icon gray" @click.prevent="shareToFriends()">发到老师微信</a></div>
          <div class="col-xs-6"><a class="icon-qq icon gray" @click.prevent="shareQQ()">发到老师QQ</a></div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      shareInfo: {}
    }
  },
  mounted: function () {
    this.shareToPeople()
    // let image = new Image()
    // image.src = $('#code canvas').get(0).toDataURL('image/png')
    // $('#code').append(image)
  },
  methods: {
    shareToPeople: function () {
      this.isideShare = false
      this.shareInfo.curcheName = this.login_data[this.cookie_login_data.index].curcheName
      this.shareInfo.teacherName = this.login_data[this.cookie_login_data.index].teacherName
      this.shareInfo.description = this.shareInfo.teacherName + '邀请你加入' + this.shareInfo.curcheName
      if (this.cookie_login_data.teacherIcon) {
        this.shareInfo.imageUrl = this.cookie_login_data.baseAcessPath + this.cookie_login_data.teacherIcon
      } else {
        this.shareInfo.imageUrl = 'http://download.shurenapp.com/invitation/assets/images/img-default.png'
      }
      this.shareInfo.title = '邀请老师'
      this.shareInfo.webpageUrl = 'http://download.kids-home.cc/invitation/invitation.html?' + 'curcheId=' + this.cookie_login_data.curcheId + '&' + 'teacherId=' + this.cookie_login_data.teacherId

      $('#code').qrcode({
        text: this.shareInfo.webpageUrl
      })
    },
    shareToTimeLine: function (para) {
      window.Wechat.share({
        message: {
          title: this.shareInfo.title,
          description: this.shareInfo.description,
          // thumb: this.shareInfo.thumb,
          messageExt: this.shareInfo.title,
          media: {
            type: window.Wechat.Type.LINK,
            webpageUrl: this.shareInfo.webpageUrl
          }
        },
        scene: window.Wechat.Scene.TIMELINE   // share to Timeline
      }, function () {
        // alert('分享成功')
      }, function (reason) {
        // alert('失败原因: ' + reason)
      })
    },
    shareToFriends: function (para) {
      window.Wechat.share({
        message: {
          title: this.shareInfo.title,
          description: this.shareInfo.description,
          thumb: this.shareInfo.thumb,
          messageExt: this.shareInfo.title,
          media: {
            type: window.Wechat.Type.LINK,
            webpageUrl: this.shareInfo.webpageUrl
          }
        },
        scene: window.Wechat.Scene.SESSION
      }, function () {
        // alert('分享成功')
      }, function (reason) {
        // alert('失败原因:' + reason)
      })
    },
    shareQQ: function (para) {
      var args = {}
      args.url = this.shareInfo.webpageUrl
      args.title = this.shareInfo.title
      args.description = this.shareInfo.description
      args.imageUrl = this.shareInfo.imageUrl
      args.appName = this.shareInfo.title
      window.YCQQ.shareToQQ(function () {
        console.log('share success')
      }, function (failReason) {
        console.log(failReason)
      }, args)
    },
    loadTop: function (id) {
      // alert('123')
      this.$refs.loadmore.onTopLoaded(id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// teacher.vue?5649b5c9